import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ButtonStyled = styled(Button)(({ theme }) => ({
  backgroundColor: '#00468D'
}));

export {
  ButtonStyled
};
